import React, { useContext } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import AuthContext from 'contexts/authContext';
import { getCoreServiceUrl } from 'helpers/domain';

const GoogleReviewQR = ({ intervention }) => {
    //console.log("intervention**", intervention)
    const { userData } = useContext(AuthContext)
    //const clientId = intervention?.client?._id
    const interventionId = intervention?._id
    /* const googleUrl = intervention?.companyId?.fiche
    const companyId = intervention?.companyId?._id */

    const apiRedirectUrl = `${getCoreServiceUrl()}/avis/scan?technicienId=${userData?.id}&interventionId=${interventionId}`;

    return (
        <div className='mb-3' style={{ textAlign: 'center', }}>
            <h5>Laissez-nous un avis !</h5>
            <p>Scannez le QR code pour nous évaluer sur Google</p>

            <div style={{                
                background: 'white',
                display: 'inline-block',
                borderRadius: '10px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}>
                <QRCodeSVG
                    value={apiRedirectUrl}
                    size={200}               
                    bgColor={"#ffffff"}      
                    fgColor={"#000000"}      
                    level={"H"}             
                    includeMargin={true}
                    imageSettings={{        
                        src: "https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_Reference_icon.svg",
                        x: undefined,
                        y: undefined,
                        height: 40,
                        width: 40,
                        excavate: true,       
                    }}
                />
            </div>
        </div>
    );
};

export default GoogleReviewQR;